<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Ocorrências | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
          <div class="form-group col-12 col-md-6">
            <label for="observacao">Motivo: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.motivo ? registro.motivo.descricao : '-' }}
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
            <span class="label" v-bind:class="{
                'label-warning': registro.idc_status === 1,
                'label-info': registro.idc_status === 2,
                'label-danger': registro.idc_status === 3,
                'label-success': registro.idc_status === 4,  
                'label-default': ![1,2,3,4].includes(registro.idc_status)
              }">{{ registro.status_desc }}</span>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="cd_motorista">Motorista: &nbsp;&nbsp;&nbsp;</label>
            <a href="#" @click="abrirMotorista(registro.cd_motorista)">{{ registro.motorista ? registro.motorista.nome : '-' }}</a>
          </div>
          <div class="form-group col-12 col-md-6">
            <label for="descricao">Criada em: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.created_at }}
          </div>
          <div class="form-group col-12 col-md-12">
            <label for="descricao">Descrição: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.descricao }}
          </div>
          <div class="form-group col-12 col-md-12">
            <label for="observacao">Observação: &nbsp;&nbsp;&nbsp;</label>
            {{ registro.observacao }}
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
            <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import OcorrenciaActions from '../../actions/OcorrenciaActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      registro: {
        descricao: '',
        observacao: '',
        idc_status: '',
        status_desc: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    OcorrenciaActions.obterOcorrencia(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res

          this.registro.created_at = this.registro.created_at ? this.formatarData(this.registro.created_at) : '-'
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/ocorrencias')
    },
    editar () {
      this.$router.push('/ocorrencias/' + this.id + '/e')
    },
    abrirMotorista (motorista) {
      this.$router.push('/motoristas/' + motorista)
    },
    formatarData (val) {
      let data = moment.utc(val)
      if (data.isValid()) {
        return data.format('DD/MM/YYYY HH:mm')
      }
      return ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/ocorrencias/Detalhes.vue